<template>
  <div
    :class="[
      bem.b(),
      bem.is('success', validateState === 'success'),
      bem.is('error', validateState === 'error')
    ]"
  >
    <label :class="bem.e('label')">
      <slot name="label">
        {{ label }}
      </slot>
    </label>
    <div :class="bem.e('content')">
      <slot></slot>
      <div :class="bem.e('error')">
        <slot name="error">
          {{ validateMessage }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, provide, ref } from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import AsyncValdaitor, { Values } from 'async-validator'
import {
  Arrayable,
  FormItemContext,
  formItemContextKey,
  formItemProps,
  FormItemRule,
  FormItemValidateState
} from './form-item'
import { formContextKey } from './form'

defineOptions({
  name: 'cms-form-item'
})

const formContext = inject(formContextKey)

const props = defineProps(formItemProps)

const bem = createNamespace('form-item')

const validateState = ref<FormItemValidateState>('')
const validateMessage = ref('')

const converArray = (
  rules: Arrayable<FormItemRule> | undefined
): FormItemRule[] => {
  return rules ? (Array.isArray(rules) ? rules : [rules]) : []
}

const _rules = computed(() => {
  const myRules: FormItemRule[] = converArray(props.rules)
  const formRules = formContext?.rules
  if (formRules && props.prop) {
    const _temp = formRules[props.prop]
    if (_temp) {
      myRules.push(...converArray(_temp))
    }
  }
  return myRules
})

const getRuleFiltered = (trigger: string) => {
  const rules = _rules.value
  return rules.filter(rule => {
    // 这种情况无论如何都要校验
    if (!rule.trigger || !trigger) {
      return true
    }
    if (Array.isArray(rule.trigger)) {
      return rule.trigger.includes(trigger)
    } else {
      return rule.trigger === trigger
    }
  })
}

const onValidationSuccessed = () => {
  validateState.value = 'success'
  validateMessage.value = ''
}
const onValidationFailed = (err: Values) => {
  validateState.value = 'error'
  const { errors } = err
  validateMessage.value = errors ? errors[0].message : ''
}

const validate: FormItemContext['validate'] = async (trigger, callback) => {
  const rules = getRuleFiltered(trigger)
  // 触发条件，找到对应的规则和数据源在哪里再进行校验那个属性
  const modelName = props.prop!
  // 拿到校验器
  const validator = new AsyncValdaitor({
    [modelName]: rules
  })
  const model = formContext?.model!
  return validator
    .validate({
      [modelName]: model[modelName]
    })
    .then(() => {
      onValidationSuccessed()
    })
    .catch(err => {
      onValidationFailed(err)
      return Promise.reject(err)
    })
}
const context: FormItemContext = {
  ...props,
  validate
}
provide(formItemContextKey, context)

onMounted(() => {
  // 将自己的上下文传递给父级
  formContext?.addField(context)
})
</script>

<style scoped></style>
